import {Typography} from 'components/Typography';
// import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
// import {MODALS} from 'modules/modals/constants';
// import {showModal} from 'modules/modals/thunks';
import {FC} from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {TIconName} from 'components/Icon/iconNames';

interface IProps {
    icon?: TIconName;
    title?: string;
}

export const ProductFeatureItem: FC<IProps> = ({icon, title}) => {
    // const dispatch = useAppDispatch();

    const handleClick = () => {
        // dispatch(showModal(MODALS.PRODUCT_RATING.name));
    };

    return (
        <button className={style.main} onClick={handleClick} type={'button'}>
            {icon && <Icon className={style.icon} icon={icon} />}
            {title && <Typography variant={'label-14-r-fluid'}>{title}</Typography>}
        </button>
    );
};
